
import * as types from './mutations_types.js';

export default {
	update_userinfo: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.UPDATE_USERINFO, 
				data
			);
			resolve()
		});
	},

	update_token: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.UPDATE_TOKEN, 
				data
			);
			resolve()
		});
	},

	remove_userinfo: ({
		commit
	}) => {
		return new Promise((resolve, reject) => {
			commit(types.REMOVE_USERINFO);
			resolve()
		});
	},

	
	update_identity: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.UPDATE_IDENTITY, 
				data
			);
			resolve()
		});
	},

	update_selectedMenu: ({
		commit
	},
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.UPDATE_SELECTEDMENU,
				data
			);
			resolve()
		});
	},

	update_userPwdFlag: ({
		commit
	},
		data
	) => {
		return new Promise((resolve, reject) => {
			commit(types.UPDATE_USERPWDFLAG,
				data
			);
			resolve()
		});
  },
  
  update_tenant: ({
    commit
  }, data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_TENANT,
        data
      );
      resolve()
    });
  },

	
	

	
};